import Api from './Api';

class StatisticApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '', headers);
  }

  get = (botId: string, payload: any) => this.instance.get(`/Statistic/${botId}`, {
    params: {
      ...payload,
    },
  });

  getLive = (botId: string, payload: any) => this.instance.get(`/Live/${botId}`, {
    params: {
      ...payload,
    },
  });
}

export default StatisticApi;
